export const assetTypes = ['container', 'chassis', 'trailer'];
export const equipmentTypes = {
    ISO_Dry: 'ISO Dry',
    ISO_High_Cube: 'ISO High Cube',
    ISO_Reefer: 'ISO Reefer',
    Domestic: 'Domestic',
    Domestic_Reefer: 'Domestic Reefer',
    Other: 'Other',
};
export const equipmentTypesLocalizationSlugs = {
    ISO_Dry: 'ISO_DRY',
    ISO_High_Cube: 'ISO_HIGH_CUBE',
    ISO_Reefer: 'ISO_REEFER',
    Domestic: 'DOMESTIC',
    Domestic_Reefer: 'DOMESTIC_REEFER',
    Other: 'OTHER',
};
export const CHASSIS_OWNERSHIP_TYPE = [
    { localizationSlug: 'CARGOMATIC', value: 'cargomatic' },
    { localizationSlug: 'CUSTOMER', value: 'customer' },
];
export const CHASSIS_COLOR_MAPPING = {
    customer: 'orange',
    cargomatic: 'green',
};
export const equipmentTypesMapping = {
    CONTAINER: 'container',
    CHASSIS: 'chassis',
    TRAILER: 'trailer'
};
export const equipmentSizes = [20, 40, 45, 48, 53];
